/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";

import firebase from "firebase/app";
import "firebase/auth";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			// =============================================================================
			// MAIN LAYOUT ROUTES
			// =============================================================================
			path: "",
			component: () => import("./layouts/main/Main.vue"),
			children: [
				// =============================================================================
				// Theme Routes
				// =============================================================================
				{
					path: "/",
					name: "home",
					component: () => import("./views/pages/home/Home.vue"),
					meta: {
						authRequired: true
					}
				},
				{
					path: "/orders",
					name: "orders",
					component: () => import("./views/pages/orders/Orders.vue"),
					meta: {
						authRequired: true
					}
				}
			]
		},
		// =============================================================================
		// FULL PAGE LAYOUTS
		// =============================================================================
		{
			path: "",
			component: () => import("@/layouts/full-page/FullPage.vue"),
			children: [
				// =============================================================================
				// PAGES
				// =============================================================================
				{
					path: "/pages/login",
					name: "page-login",
					component: () => import("@/views/pages/login/Login.vue")
				},
				{
					path: "/pages/error-404",
					name: "page-error-404",
					component: () => import("@/views/pages/Error404.vue")
				}
			]
		},
		// Redirect to 404 page, if no match found
		{
			path: "*",
			redirect: "/pages/error-404"
		}
	]
});

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById("loading-bg");
	if (appLoading) {
		appLoading.style.display = "none";
	}
});

router.beforeEach((to, from, next) => {
	firebase.auth().onAuthStateChanged(() => {
		// get firebase current user
		const firebaseCurrentUser = firebase.auth().currentUser;

		// If auth required, check login. If login fails redirect to login page
		if (to.meta.authRequired) {
			if (!firebaseCurrentUser) {
				router.push({ path: "/pages/login", query: { to: to.path } });
			}
		}

		return next();
	});
});

export default router;
